export default "__VITE_ASSET__BKXcJgh9__"